import { useMemo } from 'react'

import { BuilderDroppableElement } from '@makyoapp/makyo-common/dist/builder'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { ParentComponentProps } from '@/shared/builder/types'

import { CompTabsWrapperCore } from '../core/tabs/wrapper'

/**
 * CompTabsWrapper
 */
export default function CompTabsWrapper({
  children,
  element,
}: ParentComponentProps<{ tabElement: BuilderDroppableElement }>) {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer, activeLayerElementSettings } = useActiveLayerContext()
  const mergedAllSettings = useMemo(() => {
    const pageBodySettings = (compContext.containerClient as any)?.settings?._BodySettings || {}
    // Prefer pageBodySettings for missing keys so globals injected into page map are available immediately
    return { ...pageBodySettings, ...activeLayerElementSettings }
  }, [compContext.containerClient, activeLayerElementSettings])
  const infosProps = { ...compContext, currentParentBg, activeLayer, element, allSettings: mergedAllSettings }

  return (
    <CompTabsWrapperCore core={infosProps}>
      {(props) => {
        const tabElement = element?.children.find((childEl) => childEl.id === props.id)
        if (!tabElement) return null
        return children({ tabElement })
      }}
    </CompTabsWrapperCore>
  )
}
